import { UseQueryOptions } from '@tanstack/react-query';
import {
	SalesforceGetObjectDetailsPayload,
	SalesforceGetObjectDetailsResultPayload,
	SalesforceGetObjectsPayload,
	SalesforceGetObjectsResultPayload,
	salesforcePrefix,
	urlCombine,
} from 'ihub/common';
import {
	getTenantID,
	microServiceAPI,
	standardPost,
	validateOkResponse,
} from '../classes/http-helper-const';
import { cacheStaleTime } from '../constants';

export class SalesforceHttpService {
	private getObjectListPath = 'GetObjectList';
	private getObjectStructurePath = 'GetObjectStructure';

	getObjectListQuery(
		payload: SalesforceGetObjectsPayload
	): UseQueryOptions<SalesforceGetObjectsResultPayload, Error, SalesforceGetObjectsResultPayload> {
		return {
			queryKey: [getTenantID(), salesforcePrefix, this.getObjectListPath, payload.clientId],
			queryFn: async (): Promise<SalesforceGetObjectsResultPayload> => {
				const url = urlCombine(microServiceAPI, salesforcePrefix, this.getObjectListPath);
				const res = await standardPost(url, payload);
				await validateOkResponse(
					res,
					'get Salesforce object list',
					SalesforceGetObjectsResultPayload.name
				);
				return await res.clone().json();
			},
			staleTime: cacheStaleTime,
		};
	}

	getObjectStructureQuery(
		payload: SalesforceGetObjectDetailsPayload
	): UseQueryOptions<
		SalesforceGetObjectDetailsResultPayload,
		Error,
		SalesforceGetObjectDetailsResultPayload
	> {
		return {
			queryKey: [
				getTenantID(),
				salesforcePrefix,
				this.getObjectStructurePath,
				payload.clientId,
				payload.objectName,
			],
			queryFn: async (): Promise<SalesforceGetObjectDetailsResultPayload> => {
				const url = urlCombine(microServiceAPI, salesforcePrefix, this.getObjectStructurePath);
				const res = await standardPost(url, payload);
				await validateOkResponse(
					res,
					'get Salesforce object list',
					SalesforceGetObjectDetailsResultPayload.name
				);
				return await res.clone().json();
			},
			staleTime: cacheStaleTime,
		};
	}
}
